<header class="dialog-header">
  <h3 class="header-heading">{{ 'pages.user-cards.incomplete-profile.heading' | translate }}</h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>

<div class="dialog-content">
  
  <div class="icon">
    <mat-icon class="icon-user-profile" matBadge="!" matBadgeSize="small" matBadgeColor="warn"></mat-icon>
  </div>

  <p class="title">
    {{ 'pages.user-cards.incomplete-profile.message' | translate }}
  </p>
  <p class="error" *ngFor="let field of missingFields">{{ 'pages.user-cards.incomplete-profile.fields.' + field | translate }}</p>
</div>
  